import React, { useEffect, useState } from 'react';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  UtilityText,
  Checkbox,
  Fieldset,
  FormField,
} from '@leagueplatform/genesis-core';
import { FraudModal } from '../../../layout/fraudModal';
import { updateFormData } from '../../../helpers';

export function AcknowledgementInformation(props: any) {
  const { errorHandling, nextButtonClicked, footerToBottom } = props;

  const [form, setForm] = useState({
    fraudAcknowledgement: false,
  });

  const [isFraudError, setIsFraudError] = useState(false);
  const [fraudError, setFraudError] = useState('');

  const isValid = form.fraudAcknowledgement;

  useEffect(() => {
    footerToBottom(false);
  }, [footerToBottom]);

  useEffect(() => {
    if (form.fraudAcknowledgement) {
      errorHandling(true);
    } else {
      errorHandling(false);
    }
  }, [form, errorHandling]);

  useEffect(() => {
    if (nextButtonClicked) {
      if (!isValid) {
        if (!form.fraudAcknowledgement) {
          setIsFraudError(true);
          setFraudError('This selection is required.');
        }
      }
    }
  }, [nextButtonClicked, isValid, form]);

  const onUpdate = (e: any) => {
    const { checked } = e.target;
    setForm({
      fraudAcknowledgement: checked,
    });
    setIsFraudError(false);
    setFraudError('');
  };

  useEffect(() => {
    const pInfo = JSON.parse(sessionStorage.getItem('formData') || '{}');
    if (pInfo) {
      setForm({
        fraudAcknowledgement: pInfo?.fraudAcknowledgement,
      });
    }
  }, []);

  useEffect(() => {
    if (form) {
      updateFormData(form);
    }
  }, [form]);

  return (
    <StackLayout
      css={{ backgroundColor: 'White' } as GDSStyleObject}
      horizontalAlignment="center"
    >
      <Box
        css={
          {
            display: 'flex',
            flexDirection: 'column',
            padding: '$three $two $two $two',
          } as GDSStyleObject
        }
      >
        <HeadingText
          level="1"
          size={{
            '@initial': 'xxl',
            '@mobile': 'xl',
            '@mobileLandscape': 'xl',
            '@tablet': 'xl',
            '@laptop': 'xxl',
            '@desktop': 'xxl',
          }}
        >
          Direct Reimbursement Claim Form
        </HeadingText>
        <Box
          css={
            {
              marginTop: '$two',
              marginBottom: '$one',
            } as GDSStyleObject
          }
        >
          <HeadingText
            level="3"
            size={{
              '@initial': 'xl',
              '@mobile': 'lg',
              '@mobileLandscape': 'lg',
              '@tablet': 'xl',
              '@laptop': 'xl',
              '@desktop': 'xl',
            }}
          >
            Step 5: Acknowledgement/Certification
          </HeadingText>
        </Box>
        <Box
          css={
            {
              display: 'flex',
              maxWidth: '600px',
            } as GDSStyleObject
          }
        >
          <UtilityText>
            I certify that the information on this form is correct and authorize
            the provider to release appropriate information necessary to process
            the claim to plan provisions. Additionally, I have read and
            understand the fraud statement.
          </UtilityText>
        </Box>
        <Box>
          <FraudModal fraudLabel="Fraud Statement" />
          <FormField
            id="fraudAcknowledgement"
            label=""
            statusIconLabel="Error"
            inputStatus={isFraudError ? 'error' : undefined}
            statusMessage={isFraudError ? fraudError : ''}
          >
            <Fieldset
              css={
                {
                  display: 'flex',
                  maxWidth: '600px',
                } as GDSStyleObject
              }
              legend={undefined}
            >
              <Checkbox
                id="fraudAcknowledgement"
                name="fraudAcknowledgement"
                label=""
                checked={form.fraudAcknowledgement}
                onChange={(e) => onUpdate(e)}
              />
              By checking this box and clicking ‘Submit’ below, I am
              electronically signing this Vision Claim Form.
            </Fieldset>
          </FormField>
        </Box>
      </Box>
    </StackLayout>
  );
}
